export default __webpack_public_path__ + "static/media/site_banner_en.6dc27a0d.m4v";